export const coronaSeason = true;

export const maxExpiry = 999999;
